import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import ReactTooltip from 'react-tooltip';
import { Stack, Inline, Text, textVariants } from '@etg/wings';
import { useEffect, useState } from 'react';
import { screenReaderOnly } from '../../../common/utils/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const genericStyles = css`
  max-width: 240px;
`;
const SeatToolTip = _ref => {
  let {
    id,
    price,
    seat,
    seatTypeLabel
  } = _ref;
  const {
    t
  } = useTranslation();
  const [seatId, setSeatId] = useState('');
  useEffect(() => {
    setSeatId(id);
  }, [id]);
  const formattedPrice = priceUtil.formatPrice(price);
  const labels = {
    tooltipPriceLabel: t('Product.SeatMap.Tooltip.Price'),
    tooltipSeatLabel: t('Product.SeatMap.Tooltip.Select')
  };
  return /*#__PURE__*/_jsxs(ReactTooltip, {
    className: cx('etiTooltip', genericStyles),
    effect: "solid",
    event: "focus mouseover",
    eventOff: "blur mouseout",
    globalEventOff: "touchstart blur",
    id: id,
    children: [/*#__PURE__*/_jsxs(Stack, {
      "aria-hidden": "true",
      children: [/*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: `${labels.tooltipSeatLabel}:`
        }), /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: seat
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: labels.tooltipPriceLabel
        }), /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: formattedPrice
        })]
      })]
    }), /*#__PURE__*/_jsx("span", {
      className: screenReaderOnly,
      children: `${seatTypeLabel}. ${labels.tooltipSeatLabel} ${seat} ${formattedPrice}`
    })]
  }, `key-${seatId}`);
};
export default SeatToolTip;
//# sourceMappingURL=SeatTooltip.js.map